import styl from 'styled-components';

export default styl.div(
  ({theme}) => `
  position: relative;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  white-space: pre-wrap;
  border-radius: 4px;
  color: ${theme.color.grey[12]};

  & .loader{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  h1 {
    font-size: 32px;
    line-height: 140%;
    letter-spacing: -0.64px;
    font-weight: 700;
    margin: 20px 0;
  }

  h2 {
    font-size: 28px;
    line-height: 140%;
    letter-spacing: -0.56px;
    font-weight: 700;
    margin: 20px 0 10px;
  }

  h3 {
    font-size: 24px;
    line-height: 140%;
    letter-spacing: -0.48px;
    font-weight: 700;
    margin: 20px 0 10px;
  }

  h4 {
    font-size: 20px;
    line-height: 140%;
    letter-spacing: -0.4px;
    font-weight: 700;
    margin: 20px 0 10px;
  }

  h5 {
    font-size: 16px;
    line-height: 140%;
    letter-spacing: -0.32px;
    font-weight: 700;
    margin: 20px 0 10px;
  }

  h6 {
    font-size: 14px;
    line-height: 140%;
    letter-spacing: -0.28px;
    font-weight: 700;
    margin: 20px 0 10px;
  }

  p, ul, li {
    font-size: 14px;
    line-height: 140%;
    letter-spacing: -0.28px;
    font-weight: 400;
    margin-bottom: 10px;
    text-align: justify;
  }

  strong {
    font-weight: 700;
  }

  blockquote {
    align-self: stretch;
    color: ${theme.color.grey[14]}
    font-family: Inter;
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: -0.28px;
    padding: 24px;
    border-radius: 0px 4px 4px 0px;
    border-left: 2px solid ${theme.color.indigo[6]};
    background: ${theme.color.grey[3]};
  }

  code {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: -0.24px;
    padding: 4px 8px;
    border-radius: 4px;
    background: ${theme.color.grey[3]};
    color: ${theme.color.grey[14]};
  }

  pre code {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: -0.24px;
    display: flex;
    color: ${theme.color.white};
    background-color: ${theme.color.grey[15]};
    border-radius: 4px;
    padding: 12px;
    text-wrap: wrap;
  }

  *:link {
    color: ${theme.color.indigo[6]};
    text-decoration-line: underline;

    &:hover {
      color: ${theme.color.indigo[5]};
    }
  }

  hr {
    width: 100%;
    border-radius: 4px;
    border-top: 1px solid ${theme.color.grey[4]};
    border-left: transparent;
  }

  table {
    width: 100%;
    border-radius: 4px;
    border-collapse: collapse;
    border: 1px solid ${theme.color.grey[4]};
    text-align: left;

    th {
      border: 1px solid ${theme.color.grey[4]};
      background: ${theme.color.grey[3]};
      padding: 12px;

      color: ${theme.color.grey[14]};
      font-size: 12px;
      font-style: normal;
      font-weight: 700;
      line-height: 140%;
      letter-spacing: -0.24px;
    }
    td {
      padding: 12px;
      border: 1px solid ${theme.color.grey[4]};
      color: ${theme.color.grey[14]};
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
      letter-spacing: -0.24px;
    }
  }
  `,
);
